import { makeObservable, observable, runInAction } from 'mobx';
import { AvailabilityCalendar as AvailabilityCalendarModel } from '@data/models';
import { AvailabilityCalendarService } from '@data/api';
import TimeUtils from '@business/utils/time';

export default class AvailabilityCalendar {
  @observable model: AvailabilityCalendarModel | null = null;

  constructor() {
    makeObservable(this);
  }

  search = async (options: {
    propertyId?: number;
    startDate?: Date | string;
    endDate?: Date | string;
  }) => {
    const { propertyId } = options;
    const start_date = options.startDate
      ? TimeUtils.format(options.startDate)
      : TimeUtils.format(TimeUtils.getDateOffset(0));
    const end_date = options.endDate
      ? TimeUtils.format(options.endDate)
      : TimeUtils.format(TimeUtils.getDateOffset(0, 0, 2, start_date));

    const result = !propertyId
      ? null
      : await AvailabilityCalendarService.search({
          property_id: propertyId,
          start_date,
          end_date,
        });

    runInAction(() => {
      this.model = result;
    });

    return result;
  };
}
